import { motion } from 'framer-motion';

const orbs = [
  { size: 600, x: '15%', y: '20%', duration: 25, dx: 80, dy: 60, opacity: 0.04 },
  { size: 500, x: '75%', y: '10%', duration: 30, dx: -70, dy: 90, opacity: 0.035 },
  { size: 450, x: '60%', y: '65%', duration: 35, dx: 100, dy: -80, opacity: 0.045 },
  { size: 550, x: '25%', y: '75%', duration: 40, dx: -90, dy: 70, opacity: 0.03 },
];

const AmbientBackground = () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  return (
    <div className="fixed inset-0 -z-10 pointer-events-none overflow-hidden" aria-hidden="true">
      {orbs.map((orb, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full"
          style={{
            width: orb.size,
            height: orb.size,
            left: orb.x,
            top: orb.y,
            background: `radial-gradient(circle, hsl(var(--primary) / ${orb.opacity}) 0%, transparent 70%)`,
          }}
          animate={
            prefersReducedMotion
              ? {}
              : {
                  x: [0, orb.dx, -orb.dx * 0.5, 0],
                  y: [0, -orb.dy, orb.dy * 0.7, 0],
                }
          }
          transition={{
            duration: orb.duration,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
};

export default AmbientBackground;
